export const SUPPORTED_LANGS = ['en', 'es'];
export type SupportedLang = typeof SUPPORTED_LANGS[number];

export const DEFAULT_LANG: SupportedLang = 'es';
